import { useState } from "react"
import { useShallow } from "zustand/react/shallow"

// components
import { PrimeButton } from "components-design-system"
import Modal from "components/Modal/Modal"
import { Select, InputNumber } from "components-design-system"
import Checkbox from "components/Checkbox/Checkbox"
import Label from "components/Label/Label"

// context
import useAuthoringViewStore from "../../../hooks/stores/useAuthoringViewStore"

const Msc = (props) => {
  const [selectedRow, setSelectedRow] = useState(null)

  const { protocolData, tableData, setTableData, schema } = props

  const { readOnly, showPagePreview, customTableWidthClassName, showRegistryBadges } = useAuthoringViewStore(
    useShallow((state) => ({
      readOnly: state.readOnly,
      showPagePreview: state.showPagePreview,
      customTableWidthClassName: state.customTableWidthClassName,
      showRegistryBadges: state.showRegistryBadges,
    }))
  )

  const getTotalEEASubjects = () => {
    if (tableData?.length === 0 || !tableData) return 0

    let total = 0
    tableData.forEach((item) => {
      total += Number(item.subjects)
    })

    return total
  }

  const getTotalSubjects = () => {
    if (!tableData || tableData.length === 0) return 0

    let total = 0
    tableData.forEach((item) => {
      total += Number(item.subjects)
    })

    if (protocolData?.study_scope?.enrollment_number) {
      total += Number(protocolData.study_scope.enrollment_number)
    }

    return total
  }

  const getRestOfWorldSubjects = () => {
    let total = 0
    if (protocolData?.study_scope?.enrollment_number) {
      total = protocolData.study_scope.enrollment_number
    }
    return total
  }

  const addMemberStates = () => {
    let item = {
      country: "",
      rms: tableData.length === 0 ? true : false,
      first_submission_date: "",
      subjects: 0,
    }

    setTableData([...tableData, item])
  }

  const handleChange = (e, key, i) => {
    console.log({ e, key, i })
    let item = tableData[i]
    let tempData = [...tableData]
    if (key === "country") {
      let exists = tableData.some((item) => item.country === e)
      if (!exists) item[key] = e
    } else if (key === "rms") {
      if (e === true) {
        tempData.forEach((item, i) => {
          tempData[i].rms = false
        })
        item[key] = e
      }
    } else {
      item[key] = e
    }
    tempData.splice(i, 1, item)
    setTableData(tempData)
  }

  const onDeleteRow = () => {
    let tempData = [...tableData]
    tempData.splice(selectedRow, 1)
    setTableData(tempData)
    setSelectedRow(null)
  }

  const classNames = ["results-table", "member-states-concerned-container", customTableWidthClassName]

  return (
    <div className={classNames.join(" ")}>
      <table>
        <thead>
          <tr>
            <td className="header-column">Member states concerned</td>
            <td
              className="header-column"
              style={{ width: 150, maxWidth: 150 }}
            >
              RMS
            </td>
            <td className="header-column">First submissions date</td>
            <td className="header-column">Subjects</td>
          </tr>
        </thead>
        <tbody>
          {tableData?.map((row, i) => {
            return (
              <MemberStateRow
                key={i}
                i={i}
                row={row}
                handleChange={handleChange}
                schema={schema}
                readOnly={readOnly || showPagePreview}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
              />
            )
          })}
        </tbody>
      </table>
      {readOnly !== true && showPagePreview !== true && (
        <PrimeButton
          type="add"
          style={{
            marginTop: 16,
          }}
          size="small"
          onClick={addMemberStates}
        >
          Add member states
        </PrimeButton>
      )}
      <div className="member-states-concerned-details-container">
        <div className="member-states-concerned-total-container">
          <Label style={{ marginBottom: 16 }}>Countries outside the European Economic Area</Label>
          <div className="member-states-concerned-totals-container">
            <div className="member-states-concerned-total-subjects-container">
              <Label>Rest of the world subjects*</Label>
              <p className="member-states-concerned-total-item-value">{getRestOfWorldSubjects()}</p>
            </div>
          </div>
        </div>
        <div className="member-states-concerned-total-container">
          <Label style={{ marginBottom: 16 }}>Estimated total population for the trial</Label>
          <div className="member-states-concerned-totals-container">
            <div className="member-states-concerned-total-subjects-container">
              <Label>EEA subjects</Label>
              <p className="member-states-concerned-total-item-value">{getTotalEEASubjects()}</p>
            </div>
            <div className="member-states-concerned-total-subjects-container">
              <Label>Rest of the world subjects*</Label>
              <p className="member-states-concerned-total-item-value">{getRestOfWorldSubjects()}</p>
            </div>
            <div className="member-states-concerned-total-subjects-container">
              <Label>Total subjects</Label>
              <p className="member-states-concerned-total-item-value">{getTotalSubjects()}</p>
            </div>
          </div>
        </div>
      </div>
      <Modal
        type="delete"
        title="Delete Member State"
        message="You can't undo this action."
        open={selectedRow !== null}
        onCancel={() => setSelectedRow(null)}
        onOk={() => onDeleteRow()}
      />
    </div>
  )
}

export default Msc

const MemberStateRow = (props) => {
  const [showDelete, setShowDelete] = useState(false)
  const { i, row, readOnly, setSelectedRow, handleChange, schema } = props

  return (
    <tr
      onMouseEnter={() => setShowDelete(true)}
      onMouseLeave={() => setShowDelete(false)}
    >
      <td>
        <div className="country-member-state-container">
          <Select
            id={"country-member-state-field-" + i}
            placeholder={"Select country"}
            readOnly={readOnly}
            value={row.country}
            options={schema?.options}
            onChange={(val) => handleChange(val, "country", i)}
            style={{ width: "100%" }}
          />
          {readOnly !== true && (
            <i
              onClick={() => setSelectedRow(i)}
              className={`fal fa-trash-alt delete-member-state ${showDelete && "show-delete-state"}`}
            />
          )}
        </div>
      </td>
      <td>
        {readOnly !== true ? (
          <Checkbox
            readOnly={readOnly}
            checked={row.rms}
            onChange={(e) => handleChange(e.target.checked, "rms", i)}
          />
        ) : row.rms === true ? (
          "Proposed"
        ) : (
          ""
        )}
      </td>
      <td>{row.first_submission_date}</td>
      <td style={{ position: "relative" }}>
        {readOnly !== true ? (
          <InputNumber
            readOnly={readOnly}
            value={row.subjects}
            placeholder="Enter subjects"
            style={{ width: "100%" }}
            onChange={(e) => handleChange(e, "subjects", i)}
          />
        ) : (
          row.subjects
        )}
      </td>
    </tr>
  )
}
